<app-attendee-chips-filter
  [buttonText]="'attendee.price.modal.title' | translate"
  (resetChipsFilter)="reset()"
  (updateChipsFilter)="update()"
  [hasSelectedFilters]="hasSelectedFilters"
  [isValidButtonDisabled]="priceForm.invalid"
>
  <div [formGroup]="priceForm">
    <ng-container *ngFor="let priceRange of priceRangeConfig; let i = index">
      <app-form-radio-button
        formControlName="price"
        [label]="priceRange.label | translate"
        [htmlValue]="priceRange.label"
      ></app-form-radio-button>
    </ng-container>
  </div>
</app-attendee-chips-filter>
